import { useTranslation } from "react-i18next";
import Tooltip from "@/Components/Tooltip/Tooltip";

export interface TimingProps {
  bg?: string;
  time?: string;
  textAlign?: "left" | "center" | "right";
}

const Timing = ({ bg = "error", time, textAlign = "left" }: TimingProps) => {
  const { t } = useTranslation();
  return (
    <Tooltip content={t("thisOrderInThisLane", { value: time })}>
      <div>
        <div
          className="text-[white] px-[0.5rem]"
          style={{
            backgroundColor: bg,
            textAlign: textAlign,
            fontWeight: "900",
          }}
        >
          {time}
        </div>
      </div>
    </Tooltip>
  );
};

export default Timing;
